import { AgGrid, AgGridReact } from "@jsq/ds/core";
import { TICKETS_TABLE_PAGE_SIZE } from "../constants";
import { getTicketRowId } from "./columnHelpers";

const getPageLastRowUnknown = (params: AgGrid.GetLocaleTextParams): string => {
  const api = params.api;
  const currentPage = api.paginationGetCurrentPage();
  const pageSize = api.paginationGetPageSize();
  const startIndex = currentPage * pageSize;

  if (api.getDisplayedRowAtIndex(startIndex + pageSize - 1)) {
    return String(startIndex + pageSize);
  }

  for (let i = pageSize - 2; i >= 0; i--) {
    if (api.getDisplayedRowAtIndex(startIndex + i)) {
      return String(startIndex + i + 1);
    }
  }

  return String(startIndex);
};

export const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  suppressCellFocus: true,
  suppressRowHoverHighlight: false,
  suppressMultiSort: true,
  domLayout: "normal",
  rowHeight: 48,
  getLocaleText: (params) => {
    if (params.key === "pageLastRowUnknown") {
      return getPageLastRowUnknown(params);
    }
    return params.defaultValue;
  },
  onBodyScroll: (event) => {
    if (event.direction === "horizontal") {
      event.api.hidePopupMenu();
    }
  },
  onSortChanged: (event) => {
    event.api.paginationGoToFirstPage();
    event.api.refreshServerSide({ purge: true });
  },
  onFilterChanged: (event) => {
    event.api.paginationGoToFirstPage();
    event.api.refreshServerSide({ purge: true });
  },
  defaultColDef: {
    resizable: true,
    menuTabs: ["filterMenuTab"],
    sortable: true,
    suppressHeaderMenuButton: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: 100,
    filterParams: {
      debounceMs: 300,
    },
  },
  rowSelection: "multiple",
  suppressRowClickSelection: true,
  pagination: true,
  paginationPageSize: TICKETS_TABLE_PAGE_SIZE,
  paginationPageSizeSelector: [10, 20, 50, 100],
  rowModelType: "serverSide",
  cacheBlockSize: TICKETS_TABLE_PAGE_SIZE,
  maxBlocksInCache: 10,
  getRowId: getTicketRowId,
  suppressHorizontalScroll: false,
  enableBrowserTooltips: true,
  suppressContextMenu: true,
  sideBar: {
    position: "right",
    toolPanels: [
      {
        id: "bulkActions",
        labelDefault: "Bulk actions",
        labelKey: "bulkActions",
        iconKey: "",
        toolPanel: "bulkActionsPanel",
      },
    ],
  },
};
